import React, { useState, useEffect, useRef } from 'react';

const Typewriter = ({ phrases, typeSpeed = 80, backSpeed = 50, pauseBeforeDelete = 1500 }) => {
  const [text, setText] = useState('');
  const typingIndexRef = useRef(0);
  const phraseIndexRef = useRef(0);
  const isDeletingRef = useRef(false);

  useEffect(() => {
    let timer;

    const tick = () => {
      const currentPhrase = phrases[phraseIndexRef.current % phrases.length];
      
      if (!isDeletingRef.current) {
        // Typing forward
        const next = currentPhrase.slice(0, typingIndexRef.current + 1);
        setText(next);
        typingIndexRef.current += 1;

        if (next === currentPhrase) {
          // Finished typing, pause
          timer = setTimeout(() => {
            isDeletingRef.current = true;
            tick();
          }, pauseBeforeDelete);
          return;
        }
        timer = setTimeout(tick, typeSpeed);
      } else {
        // Deleting
        const next = currentPhrase.slice(0, typingIndexRef.current - 1);
        setText(next);
        typingIndexRef.current -= 1;

        if (next.length === 0) {
          // Finished deleting, move to next phrase
          isDeletingRef.current = false;
          phraseIndexRef.current = (phraseIndexRef.current + 1) % phrases.length;
          timer = setTimeout(tick, typeSpeed);
          return;
        }
        timer = setTimeout(tick, backSpeed);
      }
    };

    timer = setTimeout(tick, 400); // Initial delay
    return () => clearTimeout(timer);
  }, [phrases, typeSpeed, backSpeed, pauseBeforeDelete]);

  return <span aria-label={text}>{text}</span>;
};

export default React.memo(Typewriter);
